(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ezfy-slideshow"] && !Shopify.designMode) return;
  try {
    
let ezfyRuntimePromise;
function loadEzfyRuntime(root) {
  const container = root.querySelector('.EzfySlideshow-container[data-ezfy-runtime-url]');
  if (!container) return;
  if (window.tssInitializeEzfySlides) {
    window.tssInitializeEzfySlides(root);
    return;
  }
  if (!ezfyRuntimePromise) {
    ezfyRuntimePromise = new Promise(function(resolve, reject) {
      const script = document.createElement('script');
      script.src = container.dataset.ezfyRuntimeUrl;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    }).catch(function(err) {
      ezfyRuntimePromise = undefined;
      throw err;
    });
  }
  ezfyRuntimePromise.then(function() {
    window.tssInitializeEzfySlides(document);
  }).catch(function(err) { console.error('Slideshow runtime failed to load', err); });
}
let ezfyRuntimeObserver;
if ('IntersectionObserver' in window) {
  ezfyRuntimeObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      loadEzfyRuntime(entry.target.closest('.ezfy-slideshow-section'));
      ezfyRuntimeObserver.unobserve(entry.target);
    });
  }, { rootMargin: '600px 0px' });
}
function scheduleEzfyRuntime(root) {
  root.querySelectorAll('.EzfySlideshow-container[data-ezfy-runtime-url]').forEach(function(container) {
    const section = container.closest('.ezfy-slideshow-section');
    const image = container.querySelector('.EzfySlideshow-picture img');
    if (container.classList.contains('EzfySlideshow-container--instant') && image) {
      let started = false;
      function startRuntime() {
        if (started || !container.isConnected) return;
        started = true;
        loadEzfyRuntime(section);
      }
      function afterImagePaint() {
        if (Shopify.designMode) { startRuntime(); return; }
        const decoded = typeof image.decode === 'function' ? image.decode().catch(function() {}) : Promise.resolve();
        decoded.then(function() {
          requestAnimationFrame(function() { requestAnimationFrame(startRuntime); });
        });
      }
      if (image.complete) afterImagePaint();
      else {
        image.addEventListener('load', afterImagePaint, { once: true });
        image.addEventListener('error', startRuntime, { once: true });
      }
      container.addEventListener('pointerdown', startRuntime, { once: true, passive: true });
      container.addEventListener('keydown', startRuntime, { once: true });
    } else if (ezfyRuntimeObserver && !Shopify.designMode) {
      ezfyRuntimeObserver.observe(container);
    } else loadEzfyRuntime(section);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { scheduleEzfyRuntime(document); }, { once: true });
} else scheduleEzfyRuntime(document);
document.addEventListener('shopify:section:load', function(event) { scheduleEzfyRuntime(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
function loadTssProductImage(image) {
  if (!image.hasAttribute('data-tss-product-src')) return;
  const picture = image.closest('picture');
  if (picture) {
    picture.querySelectorAll('source[data-tss-product-srcset]').forEach(function(source) {
      source.srcset = source.dataset.tssProductSrcset;
      source.removeAttribute('data-tss-product-srcset');
    });
  }
  if (image.dataset.tssProductSrcset) image.srcset = image.dataset.tssProductSrcset;
  image.src = image.dataset.tssProductSrc;
  image.removeAttribute('data-tss-product-src');
  image.removeAttribute('data-tss-product-srcset');
}
let tssProductObserver;
if ('IntersectionObserver' in window) {
  tssProductObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      loadTssProductImage(entry.target);
      tssProductObserver.unobserve(entry.target);
    });
  }, { rootMargin: '600px 0px' });
}
function observeTssProductImages(root) {
  root.querySelectorAll('img[data-tss-product-src]').forEach(function(image) {
    if (tssProductObserver && !window.Shopify?.designMode) tssProductObserver.observe(image);
    else loadTssProductImage(image);
  });
}
function scheduleTssProductImages() {
  const heroImage = document.querySelector('.EzfySlideshow-container--instant .EzfySlideshow-picture img');
  let started = false;
  function observe() {
    if (started) return;
    started = true;
    observeTssProductImages(document);
  }
  if (!window.Shopify?.designMode && heroImage && !heroImage.complete) {
    heroImage.addEventListener('load', observe, { once: true });
    heroImage.addEventListener('error', observe, { once: true });
    window.addEventListener('scroll', observe, { once: true, passive: true });
  } else observe();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleTssProductImages, { once: true });
} else scheduleTssProductImages();
document.addEventListener('shopify:section:load', function(event) { observeTssProductImages(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
      this.header.querySelectorAll('tss-navigation[data-surface="desktop"]').forEach(menu => menu.closeAll?.());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-image"] && !Shopify.designMode) return;
  try {
    
function loadTssCategoryImage(image) {
  if (!image.hasAttribute('data-tss-category-src')) return;
  if (image.dataset.tssCategorySrcset) image.srcset = image.dataset.tssCategorySrcset;
  image.src = image.dataset.tssCategorySrc;
  image.removeAttribute('data-tss-category-src');
  image.removeAttribute('data-tss-category-srcset');
}
let tssCategoryObserver;
if ('IntersectionObserver' in window) {
  tssCategoryObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      loadTssCategoryImage(entry.target);
      tssCategoryObserver.unobserve(entry.target);
    });
  }, { rootMargin: '400px 0px' });
}
function observeTssCategoryImages(root) {
  root.querySelectorAll('[data-tss-category-src]').forEach(function(image) {
    if (tssCategoryObserver) tssCategoryObserver.observe(image);
    else loadTssCategoryImage(image);
  });
}
function scheduleTssCategoryImages() {
  const heroImage = document.querySelector('.EzfySlideshow-container--instant .EzfySlideshow-picture img');
  function observe() { observeTssCategoryImages(document); }
  if (!Shopify.designMode && heroImage && !heroImage.complete) {
    heroImage.addEventListener('load', observe, { once: true });
    heroImage.addEventListener('error', observe, { once: true });
    window.addEventListener('scroll', observe, { once: true, passive: true });
  } else observe();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleTssCategoryImages, { once: true });
} else scheduleTssCategoryImages();
document.addEventListener('shopify:section:load', function(event) { observeTssCategoryImages(event.target); });

  } catch(e) { console.error(e); }
})();
})();
